import { Component, Input } from '@angular/core';
import { LobI } from 'src/app/interfaces/lob.interface';
import { SectorI } from 'src/app/interfaces/segment-sector.interface';
import { KmShellI, KmType } from '../file-import/models/km-shell.interface';
import { months } from 'src/app/interfaces/month.array';

@Component({
  selector: 'app-stats-km-shell',
  templateUrl: './stats-km-shell.component.html',
  styleUrls: ['./stats-km-shell.component.css'],
})
export class StatsKmShellComponent {
  @Input() kmShell: KmShellI[] = [];
  filterData: { lob: LobI; sectors: SectorI[] }[] = [];
  sectors: SectorI[] = [];
  @Input() tipo!: KmType;

  data!: KmShellI[];
  title!: string;
  ngOnInit() {
    if (this.tipo == 'KM') {
      this.title = 'Kilómetros discriminados por LoB';
    } else {
      this.title = 'Frenadas bruscas discriminados por LoB';
    }

    this.data = this.kmShell.filter((d) => d.type == this.tipo);

    this.data.sort((a, b) => {
      const dateComparison =
        new Date(a.period).getTime() - new Date(b.period).getTime();
      if (dateComparison !== 0) {
        return dateComparison; // Si las fechas son diferentes, ordenar por fecha
      }
      // Si las fechas son iguales, ordenar por nombre (ascendente)
      return a.lob.name!.localeCompare(b.lob.name!);
    });

    this.data.forEach((d) => {
      d.sectors.sort((a, b) => a.sector.name.localeCompare(b.sector.name));
      const a = this.filterData.find((f) => f.lob.id == d.lob.id);
      if (!a) {
        this.filterData.push({
          lob: d.lob,
          sectors: d.sectors.map((s) => s.sector),
        });
        if (d.sectors.map((s) => s.sector).length > 0) {
          this.sectors = [...this.sectors, ...d.sectors.map((s) => s.sector)];
          this.sectors.push({ name: 'Total', segment: [] });
        }
      }
    });

    this.gotData = true;
  }

  gotData = false;

  months = months;
  returnKmMonth(month: number) {
    const km = this.data.filter(
      (k) => new Date(k.period).getMonth() == month - 1
    );
    return km;
  }

  returnSuma(id: string) {
    const a = this.data
      .filter((d) => d.lob.id === id)
      .reduce((count, a) => count + +a.value[0], 0);

    if (a > 0) return Number.isInteger(a) ? a : a.toFixed(2);
    else return a;
  }

  returnSumaSector(id: string, id_sector: string) {
    const filter = this.data
      .filter((d) => d.lob.id === id)
      .map((d) => d.sectors)
      .flat(); // Aplana los arrays
    const a = filter
      .filter((s) => s.sector.id === id_sector)
      .reduce((count, a) => count + +a.value[0], 0);
    if (a) {
      if (a > 0) return Number.isInteger(a) ? a : a.toFixed(2);
      else return a;
    } else return 0;
  }

  setRowSpan(s: SectorI[]) {
    if (s.length > 0) {
      return 1;
    } else {
      return 2;
    }
  }
  setColSpan(s: SectorI[]) {
    if (s.length > 0) {
      return s.length + 1;
    } else {
      return 1;
    }
  }
  setValue(value: any) {
    const a = +value;
    if (a > 0) return Number.isInteger(+value) ? value : (+value).toFixed(2);
    else return a;
  }

  show = true;
  rotate = false;

  hide() {
    this.rotate = !this.rotate;
    this.show = !this.show;
  }
}
